import { Injectable, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Observable, filter } from 'rxjs';
import { map } from 'rxjs/operators';

import { AbstractFavoritesMenuNotifierService } from '../../common';

import { FavoritesActions } from './favorites.actions';

@Injectable()
export class FavoritesMenuNotifierService extends AbstractFavoritesMenuNotifierService {
  private readonly actions$: Actions = inject(Actions);

  readonly favoritesListCreatedForArticle$: Observable<{ globalArticleId: string; listId: string }> =
    this.actions$.pipe(
      ofType(FavoritesActions.createFavoritesListSuccess),
      map(({ globalArticleId, createdList }) => ({ globalArticleId, listId: createdList.favoritesListId })),
      filter((event): event is { globalArticleId: string; listId: string } => !!event.globalArticleId),
    );
}
